import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useLoaderData } from 'react-router-dom';
import { Divider } from '@atlassian/learning-components';

import { useScreenEvent } from 'src/hooks/useScreenEvent';

import { InstructorIntro } from './children/InstructorIntro';
import { Props as LoaderProps } from './loader';
import { UpperSection } from './children/UpperSection';
import { LowerSection } from './children/LowerSection';
import { EnrolledBanner } from './children/EnrolledBanner';
import { RichContent } from '../RichContent';

export const ClassPage = () => {
  const { iltData, session, enrollBanner } = useLoaderData() as LoaderProps;

  useScreenEvent({ eventName: 'classPageScreen' });

  return (
    <>
      <div css={headerContainerStyles}>
        <UpperSection
          title={iltData?.courseTitleExternal || ''}
          duration={iltData?.duration ? `${iltData.duration} hours` : ''}
          location="Online - Remote Training (Live Instructor)"
          products={['JIRA', 'Confluence']}
        />
        <Divider color={token('color.border')} />
        <LowerSection
          {...session}
          courseName={iltData?.courseTitleExternal || ''}
          isFree={iltData?.free}
          hasConflict={true}
        />
        <Divider color={token('color.border')} />
        <EnrolledBanner {...enrollBanner} />
      </div>
      <div css={contentContainerStyles}>
        <RichContent iltData={iltData} />
        <InstructorIntro instructor={iltData?.instructor} isFree={iltData?.free} />
      </div>
    </>
  );
};

const headerContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
  width: '100%',
  paddingBottom: token('space.400'),
});

const contentContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: token('space.400'),

  [media.above.sm]: {
    flexDirection: 'row',
    gap: token('space.300'),
  },
});
